// Shared constants/helpers for the Call & Follow-up module.

// Brand accent (matches ConfigProvider colorPrimary in main.jsx).
export const BRAND = '#e27e56';

// Calendar / follow-up type colours (overridden by Settings -> followup_type)
export const TYPE_COLORS = {
  Call: '#1890ff',
  Callback: '#1890ff',
  Meeting: '#722ed1',
  'Site Visit': '#52c41a',
  'Office Visit': '#13c2c2',
  'Quotation Follow-up': '#fa8c16',
  'Material Selection': '#722ed1',
  'Payment Reminder': '#f5222d',
};

export const STATUS_COLORS = {
  Pending: 'processing',
  Completed: 'success',
  Missed: 'error',
  Cancelled: 'default',
};

export const PRIORITY_COLORS = {
  Hot: '#f5222d', Warm: '#fa8c16', Cold: '#1890ff',
  Lost: '#8c8c8c', Fake: '#722ed1', Converted: '#52c41a',
};

export const colorMap = (list = []) =>
  list.reduce((acc, s) => { acc[s.Value] = s.Color; return acc; }, {});

// Colour a calendar event by status first (missed/completed), else by type.
export const eventColor = (ev, typeColors = TYPE_COLORS) => {
  if (ev.Status === 'Missed') return '#f5222d';
  if (ev.Status === 'Completed') return '#bfbfbf';
  return typeColors[ev.FollowupType] || TYPE_COLORS[ev.FollowupType] || '#1890ff';
};
